/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Enable_MidiInputs */



/**
* | output |
* | --- |
* | "Enable MIDI Control" |
*
* @param {Options_Adr_Enable_MidiInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_enable_midi = /** @type {((inputs?: Options_Adr_Enable_MidiInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Enable_MidiInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer le contrôle MIDI")
	if (locale === "de") return /** @type {LocalizedString} */ ("MIDI-Steuerung aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita controllo MIDI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить управление MIDI")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar control MIDI")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用 MIDI 控制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("MIDIコントロールを有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("MIDI नियंत्रण सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar controle MIDI")
	return /** @type {LocalizedString} */ ("Enable MIDI Control")
});